module.exports = __webpack_public_path__ + "img/code.d7ef8adb.svg";